import { gql, type OperationVariables } from '@apollo/client';
import type { IStyleDTO } from '@sharedInterfaces/ICompanySettings';
import { setCompanyStyle } from '@store/reducer/companyReducer';
import store from '@store/store';

import GraphQL from '../graphQL';

import { styleGql } from './getCompanySettings';

const query = gql`
mutation setStyle($newStyle: StyleInput!) {
    setStyle(newStyle: $newStyle)
    ${styleGql}
},
`;

export default async function saveStyle(newStyle: IStyleDTO) {
    const variables: OperationVariables = {
        newStyle: {
            primary: newStyle.primary,
            secondary: newStyle.secondary,
            onSecondary: newStyle.onSecondary,
            onPrimary: newStyle.onPrimary,
            logoIdLight: newStyle.logoIdLight,
            logoIdDark: newStyle.logoIdDark,
        },
    };
    return GraphQL.mutate<IStyleDTO>(query, variables).then((newStyle) => {
        store.dispatch(setCompanyStyle(newStyle));
        return newStyle;
    });
}
